var _defs, _g, _g2, _g3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWcb1925(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 157.85 158.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#003f44;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M111.36,38.8h23.81l-11.33,12.25-14.91,59.99v8.67h-13.41v-.12l-10.98-41.96c-15.83,7.4-21.73,16.3-17.57,33.29l.12,.12v8.67h-13.41L34.15,45.74l-6.47-6.93h28.55l-6.47,6.93,15.03,56.64c-.35-14.56,9.59-21.15,19.53-25.66l-8.09-30.98-6.36-6.93h28.43l-6.59,7.28,6.59,24.85c10.75-4.16,20.57-8.67,23.93-18.03l.46-1.62-11.33-12.48Zm-3.01,69.93l12.83-51.43c-4.62,7.17-13.75,11.1-22.65,14.68l9.82,36.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.9,67.86c4.8,0,9.26,2.27,12.12,6.23h-7.32c-2.99-2.82-6.31-4.38-9.18-4.38-4.17,0-6.9,3.24-6.9,8,0,8.25,8.04,18.18,15.7,18.18,3.32,0,5.72-2.06,6.57-5.35h1.77c-2.78,4.55-7.45,7.2-12.75,7.2-8.21,0-14.9-6.69-14.9-14.9s6.69-14.99,14.9-14.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M148.68,97.54h-15.74l2.27-2.57v-24.33l-2.27-2.57h13.13c3.91,0,6.82,2.65,6.86,6.23,0,3.33-2.9,4.84-5.22,5.68,.63-.13,1.18-.17,1.73-.17,4.29,0,8.42,4.29,8.42,8.63,0,5.01-4.13,9.09-9.18,9.09Zm-1.18-21.72c0-4.25-2.48-7.07-6.74-7.41v16.8c.72-1.94,2.27-3.07,4.08-4.25,.84-.55,2.65-2.06,2.65-5.14Zm-.67,4.84c-.67,0-1.26,.21-1.89,.63-2.06,1.35-4.17,2.86-4.17,5.94v9.98h5.18c3.91,0,6.4-4.42,6.4-8.76,0-3.66-2.53-7.79-5.51-7.79Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M70.56,8.92h2.82V1.66l-2.77,1.42V1.79l3.26-1.66h.76V8.92h2.48v1.13h-6.55v-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M81.77,7.74c.27,.84,.82,1.4,1.85,1.4,1.47,0,2.53-1.66,2.53-3.79,0-.1-.02-.32-.02-.44-.34,1-1.36,1.69-2.55,1.69-1.94,0-3.24-1.5-3.24-3.29s1.32-3.32,3.36-3.32c1.32,0,2.37,.65,2.98,1.89,.44,.89,.6,1.87,.6,3.03,0,3.21-1.5,5.28-3.66,5.28-1.77,0-2.74-.94-3.13-2.45h1.28Zm1.94-6.66c-1.26,0-2.18,.92-2.18,2.23s.92,2.26,2.18,2.26,2.18-.92,2.18-2.26-.9-2.23-2.18-2.23Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M73.96,149.51c-1.21,0-1.87,.85-1.96,2.01h-1.33c.2-1.87,1.44-3.16,3.29-3.16s3.06,1.11,3.06,2.83c0,1.28-1.02,2.28-2.03,3.42l-2.55,2.8h4.8v1.15h-6.57v-.85l3.24-3.57c1.05-1.15,1.87-1.98,1.87-2.93,0-1.03-.7-1.7-1.82-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M82.13,154.03h-1.02v-5.52h5.5v1.15h-4.42v3.03c.34-.31,1.02-.64,1.83-.64,1.85,0,3.16,1.41,3.16,3.34s-1.36,3.32-3.26,3.32-3.23-1.15-3.45-3.01h1.26c.21,1.18,.93,1.9,2.19,1.9s2.05-.95,2.05-2.21-.83-2.23-2.06-2.23c-.8,0-1.41,.41-1.78,.87Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWcb1925);
export default __webpack_public_path__ + "static/media/WCB_1925.bb1a637fa48b33c03e0f7cbb1f38b4d1.svg";
export { ForwardRef as ReactComponent };